const unsafeTextContentPattern = /<|>|javascript:|on\w+\s*=/i

export const containsUnsafeTextContent = (value = "") =>
  unsafeTextContentPattern.test(String(value))
